module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"signUp":"Регистрация","name":"Имя:","city":"Город:","confirmPassword":"Подтверждение пароля:","done":"Зарегистрироваться","close":"Закрыть"},"uk":{"signUp":"Реєстрація","name":"Ім\u0027я:","city":"Місто:","confirmPassword":"Підтвердження паролю:","done":"Зареєструватися","close":"Закрити"}}')
  delete Component.options._Ctor
}
